import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import IconTooltip from 'shared/components/icon-tooltip';
import {flashTooltip} from 'src/redux/aptitude/actions';
import {copy} from 'shared/utils';
import {AptitudeStore} from 'src/types/store';

import styles from './dependency.module.scss';

interface Props {
  identifier: string;
  children: [React.ReactNode, React.ReactNode];
}

const Dependency = ({identifier, children}: Props) => {
  const dispatch = useDispatch();
  const shouldShowTooltip = useSelector((state: AptitudeStore) => !!state.tooltips[identifier]);

  return (
    <div>
      <div className={styles.header}>
        {children[0]}

        <div className="snippet-controls">
          <IconTooltip
            iconType="copy-r"
            iconSize={14}
            placement="top"
            open={shouldShowTooltip}
            onClick={() => {
              copy(children[1]);
              dispatch(flashTooltip(identifier));
            }}
            className={styles.icons}
          >
            Copied!
          </IconTooltip>
        </div>
      </div>

      <pre>{children[1]}</pre>
    </div>
  );
};

export default Dependency;
